export default "__VITE_ASSET__590fdfb6__"